/**
 * Converts megajoules (MJ) to kilowatt-hours (kWh)
 * 1 MJ = 0.27777777777778 kWh (1/3.6)
 *
 * @param {number} mj - Energy in megajoules
 * @returns {number} - Energy in kilowatt-hours
 */
export function mjToKwh(mj) {
    // Validate input
    if (typeof mj !== 'number' || isNaN(mj)) {
        throw new Error('Input must be a valid number');
    }

    // Conversion factor: 1 MJ = 0.27777777777778 kWh
    const conversionFactor = 0.27777777777778;

    return mj * conversionFactor;
}

/**
 * Converts kilowatt-hours (kWh) to megajoules (MJ)
 * 1 kWh = 3.6 MJ
 *
 * @param {number} kwh - Energy in kilowatt-hours
 * @returns {number} - Energy in megajoules
 */
export function kWhToMJ(kwh) {
    // Validate input
    if (typeof kwh !== 'number' || isNaN(kwh)) {
        throw new Error('Input must be a valid number');
    }

    // Conversion factor: 1 kWh = 3.6 MJ
    const conversionFactor = 3.6;

    return kwh * conversionFactor;
}
